import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LayoutDashboard, FileText, MessageSquare, Package } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/marketplace`;

const MOBILE_NAV = {
  brand_manager: [
    { path: '/marketplace/dashboard', icon: LayoutDashboard, label: 'Home', badgeKey: null },
    { path: '/marketplace/rfqs', icon: FileText, label: 'RFQs', badgeKey: 'rfqs' },
    { path: '/marketplace/orders', icon: Package, label: 'Orders', badgeKey: 'orders' },
    { path: '/marketplace/messages', icon: MessageSquare, label: 'Messages', badgeKey: 'messages' },
  ],
  vendor: [
    { path: '/marketplace/dashboard', icon: LayoutDashboard, label: 'Home', badgeKey: null },
    { path: '/marketplace/rfqs', icon: FileText, label: 'RFQs', badgeKey: 'rfqs' },
    { path: '/marketplace/orders', icon: Package, label: 'Orders', badgeKey: 'orders' },
    { path: '/marketplace/messages', icon: MessageSquare, label: 'Messages', badgeKey: 'messages' },
  ],
  admin: [
    { path: '/marketplace/dashboard', icon: LayoutDashboard, label: 'Home', badgeKey: null },
    { path: '/marketplace/admin/rfqs', icon: FileText, label: 'RFQs', badgeKey: 'rfqs' },
    { path: '/marketplace/admin/orders', icon: Package, label: 'Orders', badgeKey: 'orders' },
    { path: '/marketplace/messages', icon: MessageSquare, label: 'Messages', badgeKey: 'messages' },
  ],
};

export default function MobileBottomNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [badges, setBadges] = useState({});

  useEffect(() => {
    if (!user) return;
    const fetchBadges = async () => {
      try {
        const token = localStorage.getItem('token');
        const { data } = await axios.get(`${API}/dashboard/badges`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBadges(data);
      } catch {}
    };
    fetchBadges();
    const interval = setInterval(fetchBadges, 30000);
    return () => clearInterval(interval);
  }, [user]);

  if (!user) return null;

  const items = MOBILE_NAV[user.user_type] || MOBILE_NAV.brand_manager;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 lg:hidden safe-bottom"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-14">
        {items.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path ||
            (item.path !== '/marketplace/dashboard' && location.pathname.startsWith(item.path));
          const badgeCount = item.badgeKey ? (badges[item.badgeKey] || 0) : 0;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                isActive
                  ? 'text-blue-600'
                  : 'text-slate-400 active:text-slate-600'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div className="relative">
                <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5px]' : ''}`} />
                {badgeCount > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-[16px] bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center px-0.5" data-testid={`badge-${item.badgeKey}`}>
                    {badgeCount > 99 ? '99+' : badgeCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] leading-tight ${isActive ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
